<template>
  <r-panel :disabled="disabled" :title="title">
    <v-row dense>
      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model.number="model.iconBadgeExpires" label="Icon Badge Expires" hide-details/>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model.number="model.iconTooltipReset" label="Icon Tooltip Reset" hide-details/>
      </v-col>
    </v-row>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import {SmartOfferBundle} from "@/modules/redactor/models/smart-offer/bundle-core/SmartOfferBundle";

export default {
  name: "r-bundle-settings-panel",
  components: {RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Bundle Settings"),
    model: VueTypes.instanceOf(SmartOfferBundle)
  }
}

</script>